module.exports = __webpack_public_path__ + "static/media/nz.2e07ea85.png";